/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  loadAppData();


  // code to add multiple swipers on one page 
  const swiperSlides = document.querySelectorAll('.swiper:not(.product_imgs');
  let loopSetting = false;
  let scrollSetting = false;
  let slidesPerView = 'auto'
  swiperSlides.forEach((slide,i) => {
    slide.classList.add('swiper-'+i);
    if(slide.querySelector('.swiper-button-next') != null) slide.querySelector('.swiper-button-next').classList.add('swiper-button-next-'+i);
    if(slide.querySelector('.swiper-button-prev') != null) slide.querySelector('.swiper-button-prev').classList.add('swiper-button-prev-'+i);
    if(slide.querySelector('.swiper-pagination') != null) slide.querySelector('.swiper-pagination').classList.add('swiper-button-pagination-'+i);
    if(slide.querySelector('.swiper-scrollbar') != null)  slide.querySelector('.swiper-scrollbar').classList.add('swiper-scrollbar-'+i);

    if(slide.dataset.loop != undefined){
      loopSetting = true
    }
    if(slide.dataset.slidesPerView != undefined){
      slidesPerView = slide.dataset.slidesPerView
    }
    if(slide.dataset.scrollbar != undefined){
      scrollSetting = {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: 50
      }
    }
    // console.log('slidesPerView',slide.dataset.mobSpacebetween);


    

    var swiper = new Swiper('.swiper-'+i, {
      slidesPerView: 'auto',
      spaceBetween: slide.dataset.mobSpacebetween != undefined ? slide.dataset.mobSpacebetween : slide.dataset.spacebetween != undefined ? slide.dataset.spacebetween : 5,
      loop: loopSetting,

      scrollSetting: scrollSetting,
    
      // If we need pagination
      pagination: {
        el: '.swiper-button-pagination-'+i,
        clickable: true,
      },
    
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next-'+i,
        prevEl: '.swiper-button-prev-'+i,
      },
      breakpoints: {
        992: {
          spaceBetween: slide.dataset.spacebetween != undefined ? slide.dataset.spacebetween : 5,
        }
      },
    
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar-'+i,
      },
    });

    // console.log('swiper',swiper)
  })


  if(window.location.href.includes('/collections') && !window.location.href.includes('/products') && !window.location.href.includes('filter.v.availability=1')){
    if(document.querySelector('label[for="FilterLarge-Availability-1"]') != null){
      document.querySelector('label[for="FilterLarge-Availability-1"]').click();
    }
  }

  // select instock filter only on collection pages and if no availibility filter is selected
  if(window.location.href.includes('/collections') && !window.location.href.includes('/products') && !window.location.href.includes('filter.v.availability=1')){
    if(document.querySelector('label[for="filter-Availability-1"]') != null){
      document.querySelector('label[for="filter-Availability-1"]').click();
    }
  }

  // add slider on mobile
  if(document.querySelector('body').classList.contains('bogo-offer-page')){
    var init = false;
    var bogoswiper;
    function swiperCard() {
      if (window.innerWidth <= 991) {
        if (!init) {
          init = true;
          bogoswiper = new Swiper(".product_imgs", {
            direction: "horizontal",
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
        }
      } else if (init) {
        bogoswiper.destroy();
        init = false;
      }
    }
    swiperCard();
    window.addEventListener("load", swiperCard);
    window.addEventListener("resize", swiperCard);
  }

  // show sticky atc when main atc is not visible 
  if(window.location.href.includes('/products')){
    // Select the elements
    const targetElement = document.querySelector('.product__submit__buttons');
    const toggleElement = document.querySelector('.zrx-sticky-atc-bar');

    // Create an Intersection Observer
    if(toggleElement != null){
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio === 1) {
              // Target is 100% visible
              toggleElement.classList.remove('zrx-sticky-atc-show');
            } else {
              // Target is not 100% visible
              toggleElement.classList.add('zrx-sticky-atc-show');
            }
          });
        },
        {
          threshold: 1.0, // Fire only when the element is 100% visible
        }
      );
  
      // Observe the target element
      observer.observe(targetElement);
    }
  }

  function loadAppData() {
    if (document.querySelectorAll('[data-app-section]').length) {
      document.querySelectorAll('[data-app-section]').forEach(function (doc) {
        // add insta username
        if (doc.querySelector('#insta-feed') != null) {
          console.log('hellyy');
          let instaId = doc.dataset.instaId;
          let instaLink = doc.dataset.instaLink;
          console.log('instaId',instaId,'instaLink',instaLink);
          let customTitle = setInterval(function () {
            if (doc.querySelector('#insta-feed h2') != null) {
              clearInterval(customTitle);
              setTimeout(()=>{
                console.log('heyyy');
                console.log(doc.querySelector('#insta-feed h2'));
                doc.querySelector('#insta-feed h2').insertAdjacentHTML('beforeend', `<a class="btn btn--solid btn--large btn--primary" target="_blank" href="${instaLink}" >${instaId}</a>`);
                console.log(doc.querySelector('#insta-feed h2 a'));
                
              },2500)
             
            }
          })
        }
      })
    }
  }

if (window.innerWidth < 767 ) {
  const target = document.querySelector('.product__price--off');
  console.log(target, 'target')
}
window.addEventListener('scroll', function () {
  if (window.innerWidth < 767 ) {
    
    const target = document.querySelector('.final_atc_step');
    const wrapper = document.querySelector('.final_atc_step-wrapper');
    if (!target || !wrapper) return;
  
    const wrapperRect = wrapper.getBoundingClientRect();
  
    const isVisibleFromBottom = wrapperRect.bottom <= window.innerHeight;
    const isFullyBelowViewport = wrapperRect.top >= window.innerHeight;
  
    if (isVisibleFromBottom && !target.classList.contains('fixed')) {
      target.classList.add('fixed');
    }
  
    if (isFullyBelowViewport && target.classList.contains('fixed')) {
      target.classList.remove('fixed');
    }
  }
});


   document.querySelectorAll('[data-popup-open]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('open', '');      // Adds the 'open' attribute
        modal.removeAttribute('inert');     // Removes the 'insert' attribute
      }
    });
  });
  document.querySelectorAll('[data-popup-close]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const modal = document.querySelector('.product-modal');
      console.log(modal, 'modal')
      if (modal) {
        modal.setAttribute('inert', '');      // Adds the 'open' attribute
        modal.removeAttribute('open');     // Removes the 'insert' attribute
      }
    });
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function reRender(url) {

  const sections = [
    // 'product-images',
    // '.form__wrapper',
    // // '.product_price_block',
    // // '.product__block.product__block--lines.product__siblings',
    // '.selector-wrapper--size'
    'product-component',
    '.product__block--buttons'
  ];

  // Add loading class to all current sections
  sections.forEach(sel => {
    const el = document.querySelector(sel);
    if (el) el.classList.add('loading');
  });

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace each section
      sections.forEach(sel => {
        const currentEl = document.querySelector(sel);
        const newEl = doc.querySelector(sel);

        if (currentEl && newEl) {
          currentEl.replaceWith(newEl);
        }
      });

      // // Re-init product gallery or other scripts
      // if (typeof initProductGallery === 'function') initProductGallery();
      // if (typeof initProductScripts === 'function') initProductScripts();
      

    })
    .catch(err => console.error('⚠️ Error re-rendering product sections:', err))
    .finally(() => {
      sections.forEach(sel => {
        const el = document.querySelector(sel);
        if (el) el.classList.remove('loading');
      });
    });

    // Remove highlight from all main swatch containers
    document.querySelectorAll('.product__content radio-swatch')
      .forEach(mainswatch => mainswatch.classList.remove('current_sibling_container'));

    const mainDiv = event.target.closest('.swatches.swatch__button');
    if (mainDiv) {
      mainDiv.classList.add('current_sibling_container');

      const targetLink = mainDiv.querySelector('a');
      if (targetLink) {
        targetLink.classList.add('sibling__link--current');
      }
    }
  window.history.pushState({}, '', url);
}
